import { style } from "@vanilla-extract/css";

export const progressBarStyle = style({
  zIndex: 3,
});
